import _ from 'es-toolkit/compat';

import { Nullable } from '@clearverify/types';

import { VerifierCredentialStatus, VerifierDetailInfoFragment, VerifierUpdate } from 'src/api';
import {
  CommercialVerifierCompanyInformationFormValues,
  GovernmentVerifierCompanyInformationFormValues,
} from 'src/components/verifier/VerifierCompanyInformationForm/types';

export const resolveVerifierCommonUpdate = (
  formData:
    | CommercialVerifierCompanyInformationFormValues
    | GovernmentVerifierCompanyInformationFormValues,
): Partial<VerifierUpdate> => {
  return {
    displayName: formData.displayName,
    commercialName: formData.commercialName,
    fEIN: formData.fEIN,
    industry: _.isString(formData.industry) ? formData.industry : formData.industry?.value,

    contactEmail: formData.contactEmail?.toLowerCase() ?? formData.contactEmail,
    contactPhone: formData.contactPhone,
    websiteURL: formData.websiteURL,

    middeskBusinessId: null,
  };
};

export const resolveGovernmentVerifierUpdate = (
  formData: GovernmentVerifierCompanyInformationFormValues,
): Partial<VerifierUpdate> => {
  return {
    governmentEntityName: formData.governmentEntityName,
    department: formData.department,
    typeOfGovernment: formData.typeOfGovernment,
  };
};

export const resolveCommercialVerifierUpdate = (
  formData: CommercialVerifierCompanyInformationFormValues,
): Pick<VerifierUpdate, 'legalBusinessName'> => {
  return {
    legalBusinessName: formData.legalBusinessName,
  };
};

export const resolveVerifierLogoUpdate = (
  newLogoId: Nullable<string>,
): Pick<VerifierUpdate, 'logo'> | null => {
  if (_.isNil(newLogoId)) return null;

  return {
    logo: {
      connect: {
        id: newLogoId,
      },
    },
  };
};

export const resolveVerifierAddressUpdate = (
  formData:
    | CommercialVerifierCompanyInformationFormValues
    | GovernmentVerifierCompanyInformationFormValues,
  verifier: Nullable<VerifierDetailInfoFragment>,
) => {
  return {
    address: {
      [verifier?.address ? 'update' : 'create']: {
        street: formData.address?.street,
        state: formData.address?.state,
        city: formData.address?.city,
        zipCode: formData.address?.zipCode,
        county: formData.address?.county,
      },
    },
  };
};

export const resolveVerifierStatusUpdate = (
  verifier: Nullable<VerifierDetailInfoFragment>,
): Pick<VerifierUpdate, 'credentialStatus'> => {
  let credentialStatus: Nullable<VerifierCredentialStatus>;

  switch (verifier?.credentialStatus) {
    case VerifierCredentialStatus.Credentialed: {
      credentialStatus = VerifierCredentialStatus.AwaitingApprovalByCv;
      break;
    }

    default: {
      credentialStatus = verifier?.credentialStatus;
    }
  }

  return {
    credentialStatus,
  };
};
